import { SET_SESSION_EXPIRE_DATE } from './types';

export const actionBuilder = client => {
  const continueSession = ({ dispatch }) => {
    client.extendSession().catch(error => {
      if (error.response) {
        dispatch('processStep/handleError', { response: error.response }, { root: true });
      }
    });
  };

  const setSessionExpireDate = ({ commit }, expireDate) => {
    commit(`sessionExpiration/${ SET_SESSION_EXPIRE_DATE }`, expireDate, { root: true });
  };

  const stopSession = ({ dispatch, rootGetters }) => {
    if (rootGetters['auth/isAuthenticatedApplicant']) {
      client.logoutSsoSession(rootGetters['ui/language']);
    } else {
      dispatch('auth/stopHeartbeat', {}, { root: true });
      client.showSessionExpiredPage();
    }
  };

  return {
    continueSession,
    setSessionExpireDate,
    stopSession,
  };
};
